<template>
  <!-- 1 -->
  <section>
    <div class="container">
      <div class="feature-wrap" v-scrollanim>
        <div class="text">
          <div class="title">
            <h4>가족과 함께</h4>
            <h3>하루의 끝 <svgPlus /></h3>
          </div>
          <p>일상의 마무리를 간편한 메시지로 따뜻하게.</p>
        </div>
        <ChatExampleCard :messages="family" group="family" class="chat-card" />
      </div>
    </div>
  </section>
  <!-- 2 -->
  <section>
    <div class="container">
      <div class="feature-wrap reverse" v-scrollanim>
        <ChatExampleCard :messages="friend" group="friend" class="chat-card" />
        <div class="text">
          <div class="title">
            <h4>지인과 함께</h4>
            <h3>오랜만의 연락도 <svgPlus /></h3>
          </div>
          <p>평범 안부 인사도 특별하고 재밌게.</p>
        </div>
      </div>
    </div>
  </section>
  <!-- 3 -->
  <section>
    <div class="container">
      <div class="feature-wrap" v-scrollanim>
        <div class="text">
          <div class="title">
            <h4>비즈니스/영업</h4>
            <h3>비즈니스도 <span class="group"><svgLogoBlack class="logo" />과</span> 함께</h3>
          </div>
          <p>비즈니스 대화는 사생활 가득한 메신저 앱 말고 분리해서 문자 메시지에서 쉽게 함께 하세요.</p>
        </div>
        <ChatExampleCard :messages="business" group="business" class="chat-card" />
      </div>
    </div>
  </section>
</template>

<script>
import svgPlus from '@/svg/svgPlusPrimary'
import svgLogoBlack from '@/svg/svgLogoBlack'
import ChatExampleCard from '@/components/features/ChatExampleCard'

export default {
  data() {
    return {
      family: [
        {
          isMe: false,
          message: "밥 먹었니?"
        }, 
        {
          isMe: false,
          sticker: this.$getImgUrl(`assets/stickers/mom_1.webp`)
        },
        {
          isMe: true,
          message: '네 먹었어요 :)',
          timestamp: "오후 2:00"
        }
      ],
      friend: [
        {
          isMe: false,
          message: "잘 지내지?"
        }, 
        {
          isMe: false,
          sticker: this.$getImgUrl(`assets/stickers/friend_1.webp`)
        },
        {
          isMe: true,
          sticker: this.$getImgUrl(`assets/stickers/friend_2.webp`),
          timestamp: "오후 10:00"
        }
      ],
      business: [
        {
          isMe: false,
          message: "방금 메일로 보내드렸습니다."
        }, 
        {
          isMe: false,
          sticker: this.$getImgUrl(`assets/stickers/business_1.webp`)
        },
        {
          isMe: true,
          sticker: this.$getImgUrl(`assets/stickers/business_2.webp`),
          timestamp: "오후 3:00"
        }
      ]
    }
  },
  components: {
    svgPlus,
    svgLogoBlack,
    ChatExampleCard
  }
}
</script>

<style lang="scss" scoped>
section {
  --subtitle-font-size: 16px;
  --title-font-size: 26px;
  --copy-font-size: 16px;
  padding: 85px 0;
  background-color: white;

  @media screen and (max-width: 600px) {
    --title-font-size: 22px;
  }
}

span.group {
  display: inline-block;
  white-space: nowrap;
  line-break: pre;
}

.feature-wrap {
  width: 727px;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    &.reverse {
      flex-direction: column-reverse;
    }
  }
}

.text {
  @media screen and (max-width: 768px) {
    margin-bottom: 27px;
  }
}

.title h4 {
  color: #3B7CF3;
  font-size: var(--subtitle-font-size);
  font-weight: 500;
  margin-bottom: 4px;
}

.title h3 {
  color: #171717;
  font-weight: 700;
  font-size: var(--title-font-size);

  svg {
    display: inline-block;
    vertical-align: baseline;
    width: auto;
    height: 20px;
    @media screen and (max-width: 768px) {
      height: 24px;
      margin-left: 4px;
    }
  }
  svg.logo {
    height: 25px;
    margin-right: 9px;
  }
}

.text p {
  color: #797B80;
  font-weight: 500;
  font-size: var(--copy-font-size);
  margin-top: 11px;
  max-width: 304px;
}

// Animations
.feature-wrap.before-enter {
  // opacity: 0;
  // transform: translate3d(0, 20%, 0);
  .chat-card {
    opacity: 0;
    transform: translate3d(0, 20%, 0);
  }
  // .text h4 {
  //   opacity: 0;
  //   transform: translate3d(0, 100%, 0);
  // }

  // .text h3 {
  //   opacity: 0;
  //   transform: translate3d(0, 75%, 0);
  // }

  // .text p {
  //   opacity: 0;
  //   transform: translate3d(0, 50%, 0);
  // }
}
.feature-wrap.enter {
  // transform: translate3d(0, 0%, 0);
  // opacity: 1;
  // transition: 450ms ease-in-out opacity, 500ms ease-in-out transform;
  // transition-delay: 100ms; 
  .chat-card {
    transform: translate3d(0, 0%, 0);
    opacity: 1;
    transition: 450ms ease-in-out opacity, 500ms ease-in-out transform;
    transition-delay: 500ms; 
  }
  // .text h4 {
  //   opacity: 1;
  //   transform: translate3d(0, 0%, 0);
  //   transition: 750ms transform ease-in-out, 1s opacity ease-in-out;
  //   transition-delay: 200ms;
  // }
  // .text h3 {
  //   opacity: 1;
  //   transform: translate3d(0, 0%, 0);
  //   transition: 500ms transform ease-in-out, 750ms opacity ease-in-out;
  //   transition-delay: 100ms;
  // }
  // .text p {
  //   opacity: 1;
  //   transform: translate3d(0, 0%, 0);
  //   transition: 250ms transform ease-in-out, 750ms opacity ease-in-out;
  //   transition-delay: 100ms;
  // }

}

</style>